export default {
  'apiUrl': './api/v1'
}
